<main class="merchandise_categories">
    <div id="background"></div>
    <header>
        <header-component></header-component>
        <div class="nav">
            <h1>{{_('mobile_order')}}</h1>
            <span class="icon back" @click="app.setPage('Terminal')">
                chevron_left
            </span>
        </div>
    </header>

    <section>
        <merchandise-carousel
            :hasArrowButton="true"
            :images="pickedUpImagesInGeneral"
            v-if="pickedUpImagesInGeneral.length"
            @setMerchandiseItem="setMerchandiseItem"
            :clickable="true"
            :lang="app.getLang()"
        >
        </merchandise-carousel>

        <span before-icon="view_module" class="title"
            >{{_('category_list')}}</span
        >
        <div class="category_cards">
            <div
                class="card"
                @click="setCategory('meals_time')"
                v-if="buyableMerchandiseCategories.includes('meals_time')"
            >
                <span class="icon">schedule</span>
                <p class="category_name">{{ _('meals_time') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('pick_up')"
                v-if="buyableMerchandiseCategories.includes('pick_up')"
            >
                <span class="icon">directions_bus</span>
                <p class="category_name">{{ _('pick_up') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('meals')"
                v-if="buyableMerchandiseCategories.includes('meals')"
            >
                <span class="icon">restaurant</span>
                <p class="category_name">{{ _('meals') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('dinner')"
                v-if="buyableMerchandiseCategories.includes('dinner')"
            >
                <span class="icon">dark_mode</span>
                <p class="category_name">{{ _('dinner') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('breakfast')"
                v-if="buyableMerchandiseCategories.includes('breakfast')"
            >
                <span class="icon">light_mode</span>
                <p class="category_name">{{ _('breakfast') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('lunch')"
                v-if="buyableMerchandiseCategories.includes('lunch')"
            >
                <span class="symbol">partly_cloudy_day</span>
                <p class="category_name">{{ _('lunch') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('drinks')"
                v-if="buyableMerchandiseCategories.includes('drinks')"
            >
                <span class="icon">local_bar</span>
                <p class="category_name">{{ _('drinks') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('restaurant_drinks')"
                v-if="buyableMerchandiseCategories.includes('restaurant_drinks')"
            >
                <span class="icon">liquor</span>
                <p class="category_name">{{ _('restaurant_drinks') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('facilities')"
                v-if="buyableMerchandiseCategories.includes('facilities')"
            >
                <span class="icon">domain</span>
                <p class="category_name">{{ _('facilities') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('spa')"
                v-if="buyableMerchandiseCategories.includes('spa')"
            >
                <span class="icon">hot_tub</span>
                <p class="category_name">{{ _('spa') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('activity')"
                v-if="buyableMerchandiseCategories.includes('activity')"
            >
                <span class="icon">hiking</span>
                <p class="category_name">{{ _('activity') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('bar')"
                v-if="buyableMerchandiseCategories.includes('bar')"
            >
                <span class="icon">nightlife</span>
                <p class="category_name">{{ _('bar') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('massage')"
                v-if="buyableMerchandiseCategories.includes('massage')"
            >
                <img class="original_icon" src="/images/ic_massage.svg" />
                <p class="category_name">{{ _('massage') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('dog')"
                v-if="buyableMerchandiseCategories.includes('dog')"
            >
                <span class="icon">pets</span>
                <p class="category_name">{{ _('dog') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('glamping')"
                v-if="buyableMerchandiseCategories.includes('glamping')"
            >
                <span class="symbol">camping</span>
                <p class="category_name">{{ _('glamping') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('room_service')"
                v-if="buyableMerchandiseCategories.includes('room_service')"
            >
                <span class="icon">room_service</span>
                <p class="category_name">{{ _('room_service') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('equipment_rental')"
                v-if="buyableMerchandiseCategories.includes('equipment_rental')"
            >
                <span class="icon">laptop_mac</span>
                <p class="category_name">{{ _('equipment_rental') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('bed_making')"
                v-if="buyableMerchandiseCategories.includes('bed_making')"
            >
                <span class="icon">bed</span>
                <p class="category_name">{{ _('bed_making') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('cleaning')"
                v-if="buyableMerchandiseCategories.includes('cleaning')"
            >
                <span class="symbol">mop</span>
                <p class="category_name">{{ _('cleaning') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('souvenirs')"
                v-if="buyableMerchandiseCategories.includes('souvenirs')"
            >
                <span class="icon">shopping_bag</span>
                <p class="category_name">{{ _('souvenirs') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('anniversary')"
                v-if="buyableMerchandiseCategories.includes('anniversary')"
            >
                <span class="icon">cake</span>
                <p class="category_name">{{ _('anniversary') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('ticket')"
                v-if="buyableMerchandiseCategories.includes('ticket')"
            >
                <span class="icon">local_activity</span>
                <p class="category_name">{{ _('ticket') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('benefits')"
                v-if="buyableMerchandiseCategories.includes('benefits')"
            >
                <span class="symbol">hotel_class</span>
                <p class="category_name">{{ _('benefits') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('upgrade')"
                v-if="buyableMerchandiseCategories.includes('upgrade')"
            >
                <span class="icon">moving</span>
                <p class="category_name">{{ _('upgrade') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('option')"
                v-if="buyableMerchandiseCategories.includes('option')"
            >
                <span class="icon">shopping_cart</span>
                <p class="category_name">{{ _('option') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('request')"
                v-if="buyableMerchandiseCategories.includes('request')"
            >
                <span class="icon">chat</span>
                <p class="category_name">{{ _('request') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('cancel')"
                v-if="buyableMerchandiseCategories.includes('cancel')"
            >
                <span class="icon">cancel_presentation</span>
                <p class="category_name">{{ _('cancel') }}</p>
            </div>
            <div
                class="card"
                @click="setCategory('services')"
                v-if="buyableMerchandiseCategories.includes('services')"
            >
                <span class="icon">room_service</span>
                <p class="category_name">{{ _('services') }}</p>
            </div>
            <div
                v-if="buyableMerchandiseCategories.length % 2"
                class="card no_style_card"
            ></div>
            <div
                class="card talign_center other-card"
                @click="setCategory('other')"
                v-if="buyableMerchandiseCategories.includes('other')"
            >
                <p class="category_name">{{ _('other') }}</p>
            </div>
        </div>
    </section>

    <template
        v-if="app.house.mobile_order_caution && app.house.mobile_order_caution[app.getLang()]"
    >
        <hr />
        <section class="remarks">
            <pre>{{ app.house.mobile_order_caution[app.getLang()] }}</pre>
        </section>
        <hr />
    </template>

    <section v-if="app.mobile_ordered_count || app.gratuity_orders_count">
        <div class="card complete" @click="app.setPage('MobileOrdered')">
            <span class="icon-circle">history</span>
            <div>
                <p>{{_('mobile_ordered_history')}}</p>
            </div>
        </div>
    </section>

    <div id="cart-bar" v-if="app.cart && app.cart.orders.length">
        <button
            class="cart-btn"
            @click="app.setPage('MobileOrderApplication')"
            before-icon="shopping_cart"
        >
            {{_('cart')}} ({{ app.cart.totalAmountIncludingTax | price }})
        </button>
    </div>
    <tab-bar
        v-else
        :page="app.query.page"
        :show-notice="showNotice"
        key="showNotice"
    ></tab-bar>
</main>
